import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "bg-muted/70 animate-pulse rounded-md ring-1 ring-border/40",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
